import type { SubscribeCampaignConfig } from '../../../config/types';
import SubscribeForm from '../SubscribeForm';
import Header from '../../shared/Header';

interface Props {
  config: SubscribeCampaignConfig;
}

/** Default layout — the "row-layout-template" side-by-side hero + diagonal cut. */
export default function RowLayoutTemplate({ config }: Props) {
  return (
    <>
      <Header />
      <div className="main-container row-layout-template">
        <div className="form-outer-container">
          <div className="form-bg" id="js-subscribe-form-holder">
            <SubscribeForm config={config} />
          </div>
        </div>
        <div className="main-image">
          {config.backgroundImage && (
            <img src={config.backgroundImage} className="background-image full-height cover" alt="" />
          )}
          {config.mobileImage && (
            <img src={config.mobileImage} className="background-image-mobile full-height cover" alt="" />
          )}
        </div>
      </div>
    </>
  );
}
